import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const SobrePage = lazy(() => import('../pages/sobre/page'));
const ContatoPage = lazy(() => import('../pages/contato/page'));
const SimuladorPage = lazy(() => import('../pages/simulador/page'));
const PladurPage = lazy(() => import('../pages/pladur/page'));
const BarramentoPage = lazy(() => import('../pages/barramento/page'));
const PinturaIndustrialPage = lazy(() => import('../pages/pintura-industrial/page'));
const PinturasGeralPage = lazy(() => import('../pages/pinturas-geral/page'));
const InstalacaoPage = lazy(() => import('../pages/instalacao/page'));
const ConsertoPage = lazy(() => import('../pages/conserto/page'));
const HigienizacaoPage = lazy(() => import('../pages/higienizacao/page'));
const GaleriaPage = lazy(() => import('../pages/galeria/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/sobre',
    element: <SobrePage />,
  },
  {
    path: '/contato',
    element: <ContatoPage />,
  },
  {
    path: '/simulador',
    element: <SimuladorPage />,
  },
  {
    path: '/pladur',
    element: <PladurPage />,
  },
  {
    path: '/barramento',
    element: <BarramentoPage />,
  },
  {
    path: '/pintura-industrial',
    element: <PinturaIndustrialPage />,
  },
  {
    path: '/pinturas-geral',
    element: <PinturasGeralPage />,
  },
  {
    path: '/instalacao',
    element: <InstalacaoPage />,
  },
  {
    path: '/conserto',
    element: <ConsertoPage />,
  },
  {
    path: '/higienizacao',
    element: <HigienizacaoPage />,
  },
  {
    path: '/galeria',
    element: <GaleriaPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;